export class EventService {

	constructor() {
		this.listeners = new Map();
		this.onceListeners = new Map();
		this.triggeredLabels = new Map();
	}

	// help-function for onReady and onceReady
	// the callback function will execute,
	// if the label has already been triggered with the last called parameters
	#checkPast(label, callback) {
		if (this.triggeredLabels.has(label)) {
			callback(this.triggeredLabels.get(label));
			return true;
		} else {
			return false;
		}
	}

	resetOnce(label) {
		this.#checkPast(label, () => this.triggeredLabels.delete(label));
	}

	// execute the callback every time the label is trigger
	on(label, callback, checkPast = false) {
		this.listeners.has(label) || this.listeners.set(label, []);
		this.listeners.get(label).push(callback);
		if (checkPast)
			this.#checkPast(label, callback);
	}

	// execute the callback every time the label is trigger
	// check if the label had been already called
	// and if so execute the callback immediately
	onReady(label, callback) {
		this.on(label, callback, true);
	}

	// execute the callback onetime the label is trigger
	once(label, callback, checkPast = false) {
		this.onceListeners.has(label) || this.onceListeners.set(label, []);
		if (!(checkPast && this.#checkPast(label, callback))) {
			// label has not yet been called and
			// the callback in checkPast has not been executed
			this.onceListeners.get(label).push(callback);
		}
	}
	// execute the callback onetime the label is trigger
	// or execute the callback if the label had been called already
	onceReady(label, callback) {
		this.once(label, callback, true);
	}

	// remove the callback for a label
	off(label, callback = true) {
		if (callback === true) {
			// remove listeners for all callback functions
			this.listeners.delete(label);
			this.onceListeners.delete(label);
		} else {
			// remove listeners only with match callback functions
			let _off = (inListener) => {
				let listeners = inListener.get(label);
				if (listeners) {
					inListener.set(label, listeners.filter((value) => !(value === callback)));
				}
			};
			_off(this.listeners);
			_off(this.onceListeners);
		}
	}

	// trigger the event with the label
	trigger(label, ...args) {
		let result = false;
		this.triggeredLabels.set(label, ...args); // save all triggered labels for onReady and onceReady
		let _trigger = (inListener, label, ...args) => {
			let listeners = inListener.get(label);
			if (listeners && listeners.length) {
				listeners.forEach((listener) => {
					listener(...args);
				});
				result = true;
			}
		};
		_trigger(this.onceListeners, label, ...args);
		_trigger(this.listeners, label, ...args);
		this.onceListeners.delete(label); // callback for once executed, so delete it.
		return result;
	}
}